import {STORE_COURSES} from '../constants'

export function storeCourse(apiResponse) {
  return {type: STORE_COURSES, courses: [apiResponse]}
}

export function storeCourses(apiResponse) {
  return {type: STORE_COURSES, courses: apiResponse}
}
